/**
 * convertCamelCaseToSpaceSeparated converts a string from camel case to space separated.
 */
export const convertCamelCaseToSpaceSeparated = (string) =>
  string.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
